export enum EFullActions {
  DownloadTrack = "DownloadsModel:track-download",
  DownloadAlbum = "DownloadsModel:album-download",
}
